import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes dudaba todo el tiempo… ahora tengo claro qué hacer en cada situación.',
  name: 'Camila R.',
  role: 'Buenos Aires'
}, {
  quote: 'Me dio seguridad en la práctica, sobre todo en guardias.',
  name: 'Florencia M.',
  role: 'Córdoba'
}, {
  quote: 'Dejé de sentir que estaba improvisando todo el tiempo.',
  name: 'Lucía G.',
  role: 'Rosario'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-271">
      <div className="max-w-xl mx-auto" data-id="element-272">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-273">
          💬 ¿Qué dicen las Enfermeras que ya usan el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-274">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-5 rounded-xl" data-id="element-275">
              <div className="flex gap-0.5 mb-3" data-id="element-276">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-277" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-278">
                "{t.quote}"
              </p>
              <div data-id="element-279">
                <p className="font-bold text-white text-sm" data-id="element-280">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-281">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}